import essApi from "../axios/essApi";

class EducationalService {

    async getEducational() {
        return Promise.resolve(essApi.get(`user-educational`));
    }

    async getEducationalById(reqBody) {
      return Promise.resolve(essApi.get(`/user-educational-by-user-id/${reqBody}`));
  }

    async addEducational(reqBody) {
        return Promise.resolve(essApi.post(`user-educational`, reqBody));
    }
    async updateEducational(reqBody) {
        return Promise.resolve(essApi.put(`user-educational/${reqBody.id}`, reqBody));
    }
    async deleteEducational(id) {
        return Promise.resolve(essApi.delete(`user-educational/${id}`));
    }
}

export default EducationalService;
